export const getMenuItems = () => {
  // Items do menu ação
  return [
    { key: "1", label: "Editar Empreendimento" },
    { key: "2", label: "Excluir" },
    { key: "3", label: "Caracteristicas" },
    { key: "4", label: "Ver Apartamentos" },
  ];
};
